import { render } from "./Rooms.vue?vue&type=template&id=bb0bc1ea&scoped=true"
import script from "./Rooms.vue?vue&type=script&lang=js"
export * from "./Rooms.vue?vue&type=script&lang=js"

import "./Rooms.vue?vue&type=style&index=0&id=bb0bc1ea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bb0bc1ea"

export default script